export { default } from 'features/reward/routes/my-code-route';
